module.exports = __webpack_public_path__ + "img/default_course_image.a1658a46.png";